const awardsRoute = {
	name: '',
	path: 'awards',
	component: () => import('@/pages/awards/page-employee-awards'),
};

export default awardsRoute;



// WEBPACK FOOTER //
// ./src/router/awards/index.js